import { isSupabaseEnabled } from "../lib/supabaseClient";
import AuthScreenHeader from "../components/AuthScreenHeader";
import ResetPasswordFlow from "../components/ResetPasswordFlow";

// Where the STAFF "Reset password" email link lands (/reset-password
// — SignIn.tsx's forgot-password form sends coordinators here). Same
// shared flow as the volunteer surface, wearing the product mark and
// pointing back at /sign-in.
export default function ResetPassword() {
  if (!isSupabaseEnabled) {
    return (
      <main className="page page--sign-in">
        <div className="sign-in">
          <AuthScreenHeader
            title="Reset your password"
            subtitle="Password reset isn't available yet. Please check back soon."
          />
        </div>
      </main>
    );
  }

  return (
    <ResetPasswordFlow
      signInPath="/sign-in"
      doneMessage="Your password's been updated. Sign in with your new password."
    />
  );
}
